/**
 * Content Container Component
 */
import React from 'react';
import { Helmet } from 'react-helmet';
// import StoreHome from "../../../Views/Desktop/Content/StoreHome/StoreHome";
// import StoreDetail from "../../../Views/Desktop/Content/StoreDetail/StoreDetail";
// import ProductDetail from "../../../Views/Desktop/Content/ProductDetail/ProductDetail";
import Modal from 'react-modal';
// import Modals from '../.././../Views/Desktop/Content/Modals/Modals';
import ScrollButton from '../../../UI/ScrollButton/ScrollButton';
import LoadingSpinner from '../../../UI/LoadingSpinner/LoadingSpinner';
import { ContentError } from '../../../Error/Shared/ContentError';
// import Layouts from '../../../Views/Desktop/Content/Layouts/Layouts';
// import { ContactUs } from "../../../Views/Shared/Content/ContactUs/ContactUs";
import FeedbackModal from '../../../Feedback/FeedbackModal';
import FeedbackButton from '../../../Feedback/FeedbackButton';

import loadable from '@loadable/component';
import PopUpSurvey from '../../../Feedback/PopUpSurvey';
import GenericErrorView from '../../../Error/Shared/GenericError';

const Modals = loadable(
  () => import(/* webpackChunkName: "desktopModals" */ '../.././../Views/Desktop/Content/Modals/Modals')
);

export function ContentContainer(props) {
  var currentContentSwitchPath = props.passedAppFunctions.contentSwitchPath;
  if (props.contentData.JSONError) currentContentSwitchPath = 'JSONError';

  var Layouts = props.passedAppFunctions.chunks.Layouts;
  var ProductDetail = props.passedAppFunctions.chunks.ProductDetail;
  var StoreDetail = props.passedAppFunctions.chunks.StoreDetail;
  var StoreHome = props.passedAppFunctions.chunks.StoreHome;
  var StoreAll = props.passedAppFunctions.chunks.StoreAll;
  var ContactUs = props.passedAppFunctions.chunks.ContactUs;
  var ContactUsInternational = props.passedAppFunctions.chunks.ContactUsInternational;
  var Contest = props.passedAppFunctions.chunks.Contest;
  var StorePurchaseReturns = props.passedAppFunctions.chunks.StorePurchaseReturns;
  var Events = props.passedAppFunctions.chunks.Events;
  var Subscriptions = props.passedAppFunctions.chunks.Subscriptions;
  var Feedback = props.passedAppFunctions.chunks.Feedback;
  var MyPreferences = props.passedAppFunctions.chunks.MyPreferences;
  const Appointments = props.passedAppFunctions.chunks.Appointments;
  var ManageDillardsCard = props.passedAppFunctions.chunks.ManageDillardsCard;
  var PhoneOrderCheckout = props.passedAppFunctions.chunks.PhoneOrderCheckout;
  const needsPlaceholder =
    props.passedAppFunctions.navState.indexOf('/stores/') > -1 && props.contentData.productLayout !== 'BadStoreNumber'
      ? true
      : false;

  return (
    <main id='content_wrapper' className={`p-t-10${needsPlaceholder ? ' storePagePlaceholder' : ''}`}>
      <div
        id='content-wrapper'
        className={`${props.passedAppFunctions.siteFormat == 'tablet' ? 'container' : 'container-fluid'}`}
      >
        {
          {
            '/stores/:stateName/:name/:storeNum': (
              <StoreDetail contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/stores/:name/:storeNum': (
              <StoreDetail contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/stores': <StoreHome contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />,
            '/stores/all': <StoreAll contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />,
            '/stores/:stateName': (
              <StoreHome contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/p/:name/:productId': (
              <ProductDetail contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/p/:name/:productId/outfit': (
              <ProductDetail contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/p/:name/:productId/sale': (
              <ProductDetail contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/brand/:manufacturer': (
              <Layouts contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/brand/:manufacturer/:categoryName': (
              <Layouts contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/brand/:manufacturer/:categoryName/:pathModifier': (
              <Layouts contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/brand/sale-clearance/:manufacturer': (
              <Layouts contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/brand/sale-clearance/:manufacturer/:categoryName': (
              <Layouts contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/brand/sale-clearance/:manufacturer/:categoryName/:pathModifier': (
              <Layouts contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/c/:pathToken': <Layouts contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />,
            '/c/:pathToken/:pathModifier': (
              <Layouts contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/c/:pathToken/:pathModifier/:color': (
              <Layouts contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/c/:pathPrefix/:pathToken/:pathModifier/:color': (
              <Layouts contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/search-term/:searchTerm': (
              <Layouts contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),

            '/search-term/:searchTerm/:categoryName': (
              <Layouts contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/search-term/:searchTerm/:categoryName/:pathModifier': (
              <Layouts contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/search-term/:pathToken/:searchTerm/:categoryName/:pathModifier': (
              <Layouts contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/': <Layouts contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />,
            '/chanel/c/:pathToken': (
              <Layouts contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/contactus': <ContactUs contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />,
            '/internationalhelp': (
              <ContactUsInternational contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/returns': (
              <StorePurchaseReturns contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/events/:eventId': (
              <Events contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/store-purchase-returns': (
              <StorePurchaseReturns contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/member/subscriptions': (
              <Subscriptions contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/feedback/:templateId': (
              <Feedback
                contentData={props.contentData?.response}
                passedAppFunctions={props.passedAppFunctions}
                siteFormat={props.passedAppFunctions.siteFormat}
              />
            ),
            '/my-preferences': (
              <MyPreferences contentData={props.headerData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/member/my-appointments': <Appointments contentData={props.contentData} />,
            '/member/manage-dillards-card': (
              <ManageDillardsCard contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/checkout/phone-orders/:orderID': (
              <PhoneOrderCheckout contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
            ),
            '/error/:status': <GenericErrorView passedAppFunctions={props.passedAppFunctions} />,

            JSONError: (
              <div>
                <Helmet meta={[{ name: 'robots', content: 'noindex' }]} />
                <ContentError error={props.contentData.JSONError} />
              </div>
            ),
          }[currentContentSwitchPath]
        }
      </div>
      {props.quickViewData ? (
        <div>
          <Modal
            portalClassName={'ReactModalPortal dds'}
            isOpen={
              typeof props.quickViewData.contentData.productLayout != 'undefined' &&
              props.quickViewData.contentData.productLayout != 'Loading'
            }
            className='QvModal__Content ReactModal__KeepOpenFor_OSS'
            overlayClassName='QvModal__Overlay ReactModal__KeepOpenFor_OSS'
            onRequestClose={props.passedAppFunctions.closeQuickView}
            onAfterOpen={props.passedAppFunctions.afterOpenModal}
            shouldReturnFocusAfterClose={true}
            aria={{ label: 'QuickView' }}
          >
            <ProductDetail
              contentData={props.quickViewData.contentData}
              passedAppFunctions={props.passedAppFunctions}
            />
          </Modal>
          {typeof props.quickViewData.contentData.productLayout == 'undefined' ||
          props.quickViewData.contentData.productLayout == 'Loading' ? (
            <LoadingSpinner passedAppFunctions={props.passedAppFunctions} />
          ) : (
            ''
          )}
        </div>
      ) : (
        ''
      )}
      {props.passedAppFunctions.modalInfo &&
        props.passedAppFunctions.modalInfo.modalType &&
        props.passedAppFunctions.modalInfo.modalType == 'Loading' && (
          <LoadingSpinner passedAppFunctions={props.passedAppFunctions} />
        )}
      {props.passedAppFunctions.modalInfo && props.passedAppFunctions.modalInfo.modalType ? (
        <Modals contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
      ) : null}
      {props.passedAppFunctions.transition ? <LoadingSpinner passedAppFunctions={props.passedAppFunctions} /> : ''}
      <ScrollButton showUnder={160} />
    </main>
  );
}

export default ContentContainer;
